import { gql } from 'graphql-request';

export default gql`
  fragment Menu on MenuType {
    menuType
    rootPage: typeRootPage {
      id
      url
      title
    }
    menuItems {
      type: __typename
      ... on MenuItemBlock {
        page {
          id
          title
          url
        }
        subItems {
          id
          title
          url
        }
      }
      ... on ExternalURLItemBlock {
        title
        url
      }
    }
  }
`;
